// Lithuanian
export default {
  newVersionAvailable: 'Galima nauja versija',
  versionInfo: 'Galima nauja {appName} versija. Norėdami atnaujinti į versiją {version}, įkelkite puslapį iš naujo.',
  reload: 'Įkelti iš naujo',
  later: 'Vėliau',
  intl_addr_country: 'Šalis',
  intl_addr_address1: 'Adresas',
  intl_addr_address2: 'Adresas 2',
  intl_addr_address3: 'Adresas 3',
  intl_addr_address4: 'Adresas 4',
  intl_addr_city: 'Miestas',
  intl_addr_state: 'Valstija',
  intl_addr_zipCode: 'Pašto kodas',
  intl_addr_longitude: 'Ilguma',
  intl_addr_latitude: 'Platuma',
  intl_addr_department: 'Apskritis',
  intl_addr_suburb: 'Priemiestis',
  intl_addr_postalCode: 'Pašto kodas',
  intl_addr_province: 'Provincija',
  intl_addr_neighborhood: 'Mikrorajonas',
};
